import { OutboxMessageCriteria } from '@src/main/modules/messages/domain/message/outbox/outbox-message-criteria.interface';
import { OutboxMessage } from '@src/main/modules/messages/domain/message/outbox/outbox-message.interface';
import { OutboxMessageRepository } from '@src/main/modules/messages/domain/message/outbox/outbox-message.repository';
import { PageResponse } from '@src/main/shared/infrastructure/entity/page.entity';

export const findOutboxMessagesByCriteria = async (
  repository: OutboxMessageRepository,
  criteria: OutboxMessageCriteria,
): Promise<PageResponse<OutboxMessage>> => await repository.findByCriteria(criteria);
